import { useEffect, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export type FormStepProps = {
  index: number
  title: string
  path: string
}

export const useStepper = (steps: FormStepProps[]) => {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  // Calcula o índice do passo atual com base no pathname
  const current = useMemo(() => {
    const matchingStepIndex = steps.findIndex((step) => pathname.includes(step.path))
    return matchingStepIndex !== -1 ? matchingStepIndex : 0 // Default para 0 se não encontrar
  }, [pathname, steps])

  const isLast = current === steps.length - 1
  const isFirst = current === 0

  const handleNext = () => {
    const nextStep = steps[current + 1]
    if (nextStep) {
      navigate(nextStep.path)
    }
  }

  const handlePrev = () => {
    const prevStep = steps[current - 1]
    if (prevStep) {
      navigate(prevStep.path)
    }
  }

  const handleChange = (step: number) => {
    const targetStep = steps[step]
    if (targetStep) {
      navigate(targetStep.path)
    }
  }

  // Atualiza a navegação quando o pathname mudar
  useEffect(() => {
    const matchingStep = steps[current]
    if (matchingStep && pathname !== matchingStep.path) {
      navigate(matchingStep.path)
    }
  }, [pathname])

  return {
    step: {
      current,
      isFirst,
      isLast,
    },
    handleChange,
    handleNext,
    handlePrev,
  }
}
